import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Goes to a tab's href the way react-router's Link did: one new history entry
 * per pick. Radix Tabs reports a click twice, on mousedown and again on focus,
 * both before the route has updated, so a second report of the href already
 * on its way is dropped until the route moves.
 */
export function useTabNavigate() {
  const navigate = useNavigate();
  const { key } = useLocation();
  const pendingRef = useRef<string | null>(null);
  // The route has moved (a pick landed, or Back): the next pick navigates
  useEffect(() => {
    pendingRef.current = null;
  }, [key]);
  return (href: string) => {
    if (href === pendingRef.current) return;
    pendingRef.current = href;
    void navigate(href);
  };
}
